import { ConsolidatedActivitiesByStudent } from 'presentation/app/modules/Reports/pages/activities/consolidated/consolidated-activities-by-student';

export const MakeConsolidatedActivitiesByStudent: React.FC = () => {
  return <ConsolidatedActivitiesByStudent />;
};
